module.exports = "../../app/cells/components/landings/return_to_site_cell.rb";